import { defineComponent as y, computed as l, openBlock as a, createElementBlock as r, createVNode as h, normalizeStyle as b, normalizeClass as f, withCtx as n, Fragment as C, renderList as _, createBlock as k, renderSlot as g, createElementVNode as $, toDisplayString as w } from "vue";
import B from "./index57.js";
import S from "./index58.js";
const x = {
  class: "table-head",
  "data-name": "Table/Head"
}, F = { class: "table-head-text" }, T = /* @__PURE__ */ y({
  __name: "BaseTableHead",
  props: {
    headers: {},
    type: { default: "type1" },
    preset: { default: "gray" },
    customColor: {}
  },
  emits: ["sort"],
  setup(s, { emit: c }) {
    const e = s, i = c, d = {
      gray: "table-head-type2-gray",
      blue: "table-head-type2-blue",
      pink: "table-head-type2-pink"
    }, p = l(() => {
      const t = ["table-head-row", `table-head-type-${e.type}`].join(" ");
      return e.type === "type2" ? `${t} ${d[e.preset]}` : t;
    }), u = l(() => e.type === "type2" && e.customColor ? {
      backgroundColor: e.customColor,
      borderBottom: `2px solid ${e.customColor}`
    } : e.type === "type1" ? {
      backgroundColor: "#F5F6F6"
    } : {}), m = (t) => {
      i("sort", t);
    };
    return (t, v) => (a(), r("thead", x, [
      h(S, {
        class: f(p.value),
        style: b(u.value),
        type: "header"
      }, {
        default: n(() => [
          (a(!0), r(C, null, _(s.headers, (o) => (a(), k(B, {
            key: o.key,
            type: "header",
            align: o.align,
            width: o.width,
            onClick: (z) => m(o.key)
          }, {
            default: n(() => [
              g(t.$slots, "head-cell", { header: o }, () => [
                $("span", F, w(o.title), 1)
              ])
            ]),
            _: 2
          }, 1032, ["align", "width", "onClick"]))), 128))
        ]),
        _: 3
      }, 8, ["class", "style"])
    ]));
  }
});
export {
  T as default
};
